module.exports = __webpack_public_path__ + "img/user_check.82df20f5.png";